import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '@drf/environments';

import { PortfolioRequest, PortfolioResponse } from '../models';
import { PortfolioApi } from './portfolio-api.token';

@Injectable()
export class PortfolioService implements PortfolioApi {
  readonly #http = inject(HttpClient);

  getPortfolio(request: PortfolioRequest): Observable<PortfolioResponse> {
    return this.#http.post<PortfolioResponse>(`${environment.apiHost}/portfolio`, request);
  }
}
